import styled from "styled-components";
import { Close, Search } from "@mui/icons-material";

export const Form = styled.form`
  display: flex;
  height: 56px;
  border-radius: 2px;
  position: relative;
  margin-right: 16px;
  align-items: center;
`;

export const Input = styled.input`
  flex: 1;
  width: 294px;
  height: 56px;
  padding: 16px 12px;
  padding-right: 40px;
  gap: 16px;
  border-radius: 2px 0 0 2px;
  font-size: 14px;
  line-height: 20px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.23);
  background: var(--luft-secondary);
  color: #fff;

  ::placeholder {
    color: rgba(255, 255, 255, 0.70);
  };

  :focus {
    outline: none;
    border: 1px solid #fff;
    caret-color: #fff;
  };

  :-webkit-autofill {
    background: var(--luft-secondary) !important;
    -webkit-box-shadow: 0 0 0 30px var(--luft-secondary) inset !important;
    -webkit-text-fill-color: #fff !important;
  }
`;

export const StyledSearch = styled(Search)`
  && {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 12px;
    top: 16px;
    cursor: pointer;
    color: var(--bg-filte);
  }
`;

export const StyledClose = styled(Close)`
  && {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 12px;
    top: 16px;
    cursor: pointer;
    align-self: center;
    fill: #fff;
  }
`;
